import { useRouter } from "next/router"
import { formatName } from "../../constants/stateCityDictionary"
import { buildUrl } from "../../util/string"
import * as config from "../../util/config"
import { Anchor } from "@/app/components/anchor"

/**
 * Entity clarification + internal links block for pet shipping pages.
 * Appears on both city and state pages.
 */
export default function PetShippingEntityBlock() {
  const router = useRouter()
  const { city, state } = router.query

  const formattedState = formatName(state as string)
  const isCity = !!city
  const appHost = config.getAppHost()

  return (
    <div className="mt-10 mb-6 font-inter">
      {/* Entity Clarification */}
      <p className="text-base text-gray-600 leading-7 mb-6">
        CitizenShipper does not employ drivers or transport pets directly. All
        transport is handled by independent contractor drivers who pass{" "}
        <Anchor
          href="/trust-safety-hub/transporter-verification/"
          className="text-link underline"
        >
          identity verification and background checks
        </Anchor>{" "}
        on the platform.{" "}
        {isCity
          ? "This page covers pet transport only."
          : "This page covers pet transport in " +
            formattedState +
            " only."}{" "}
        For car, motorcycle, boat, or other items shipping, visit{" "}
        <Anchor
          href={buildUrl(appHost, "/shipments/new")}
          className="text-link underline"
        >
          our shipment listing form
        </Anchor>
        .
      </p>
    </div>
  )
}
